import { COMMON_FLAGS, useCommonConfig } from '../../../../taboola-common-frontend-modules/account-configurations';
import { TITLE_WARNING_THRESHOLD } from '../../../config';
import { useCreativeCampaignData } from '../../creative-creator/hooks/useCreativeCampaignData';
import { isAppleTargeting } from '../../creative-creator/utils/isAppleTargeting';
import { isMailTargeting } from '../../creative-creator/utils/isMailTargeting';

const useMaxLength = ({ isTargetingApple, isTargetingMail }) => {
    const {
        [COMMON_FLAGS.APPLE_MAX_LENGTH_CREATIVE_TITLE_THRESHOLD]: maxAppleLength,
        [COMMON_FLAGS.MAIL_MAX_LENGTH_CREATIVE_TITLE_THRESHOLD]: maxMailLength,
    } = useCommonConfig([
        COMMON_FLAGS.APPLE_MAX_LENGTH_CREATIVE_TITLE_THRESHOLD,
        COMMON_FLAGS.MAIL_MAX_LENGTH_CREATIVE_TITLE_THRESHOLD,
    ]);

    if (isTargetingApple) {
        return maxAppleLength;
    }
    if (isTargetingMail) {
        return maxMailLength;
    }
    return TITLE_WARNING_THRESHOLD;
};
export const useCreativeMaxTitleLengthThreshold = () => {
    const { fetchedCampaign: campaign } = useCreativeCampaignData();
    const isTargetingApple = isAppleTargeting(campaign);
    const isTargetingMail = isMailTargeting(campaign);
    return useMaxLength({ isTargetingApple, isTargetingMail });
};
